define('common/module/realtime/Serum.RealtimeWidget',[
  'common/module/realtime/Serum.RealtimeUpdater',
  'common/module/asset/Serum.Asset.Fragment'
], function(RealtimeUpdater, Fragment) {
  'use strict';

  var updater = RealtimeUpdater.get();

  function RealtimeWidget($widget, perspective) {

    var id = $widget.attr('data-id');

    perspective = $widget.attr('data-perspective') || perspective || 'RICH';
    var secondary = $widget.attr('data-secondary');


    function getRenderID() {
      var $parent = $widget.parent();
      var referenceID = $parent.attr('data-reference-id');

      return referenceID || id;
    }

    function destroy() {
      updater.removeTarget(id, $widget);
      $widget.off('realtimeupdate', onUpdate);
    }

    function onUpdate(event, data) {
      if (data.id !== id) {
        return false;
      }

      event.stopPropagation();
      event.stopImmediatePropagation();

      var params = { perspective : perspective};
      if (secondary) {
        params.secondary = secondary;
      }

      Fragment.render(getRenderID(), $widget.parent(), params, {
        stripWhitespace : false
      });

      destroy();
      return false;
    }

    $widget.on('realtimeupdate', onUpdate);
    $widget.on('delete', destroy);

    return {
      destroy: destroy
    };
  }

  return RealtimeWidget;
});
